import KomentarRaporAspek from "../../../../../components/categories/siakad/lms/rapor/subpage/komentar_aspek/Home";
export default function Home() {
  
  return (
    <KomentarRaporAspek />
  );
}
